import React from 'react';

const ButtonWalletCripto = ({ imageSrc, label, onClick, bgColor = 'bg-[#1a1b22]', borderColor = 'border', setCurrencyCoin, currencyCoin }) => {
  return (
    <button
      onClick={() => setCurrencyCoin(label)}
      className={`w-full h-[72px] bg-[${currencyCoin == label ? bgColor : 'transparent'}] flex flex-col gap-2 items-center justify-center rounded-lg `}
    >
      {imageSrc &&
        <img src={imageSrc} className="h-4 w-4" alt="cripto wallet" />
      }
      <p className="text-base text-white">{label}</p>
    </button>
  );
};

export default ButtonWalletCripto;
